<template>
  <table class="table">
    <thead>
    <tr>
      <th>Weight Range (lbs)</th>
      <th>Transportation Charge</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="weightRange in weightLookup">
      <td>{{weightRange.min + 1}}-{{weightRange.max}}</td>
      <td>{{weightRange.price | formattedPrice}}</td>
    </tr>
    <tr>
      <td>FTL</td>
      <td><a href="/contact">Call for Quote</a></td>
    </tr>
    <tr>
      <td>48 Hour Service</td>
      <td>Standard</td>
    </tr>
    <tr>
      <td>24 Hour/Same Day</td>
      <td>additional charges may apply</td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import {clearanceFeeLookup, weightLookup} from '../pricing'

export default {
  components: {},
  props: {},
  data: () => ({
    weightLookup
  }),
}
</script>
